import { render } from "./dashboard_organizer_lucky_draw.vue?vue&type=template&id=27d27c73&scoped=true"
import script from "./dashboard_organizer_lucky_draw.vue?vue&type=script&lang=js"
export * from "./dashboard_organizer_lucky_draw.vue?vue&type=script&lang=js"

import "./dashboard_organizer_lucky_draw.vue?vue&type=style&index=0&id=27d27c73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d27c73"]])

export default __exports__